export default {
  ZEN_DECIMAL_PLACES: 8,
  ZEN_TO_KALAPA_RATIO: '100000000',
  MINIMUM_DIVIDED_UNIT: '0.00000001',
  NUMBERS_DELIMITER: ',',
  ZP_SHORT_ID: '00',
  ZP_FULL_ID: '000000000000000000000000000000000000000000000000000000000000000000000000',
};
